module.exports = __webpack_public_path__ + "static/media/parts_mail.36812ed9.svg";